<template>
  <div>
    <section class="arsenals">
      <h3
        v-if="!(hide_pro || hide_standard) && !arsenal_added && !order.products.arsenal_pro.prepopulated && !order.products.arsenal.prepopulated"
        class="text-center"
      >
        Choose Your Arsenal 2
      </h3>
      <!-- <h3 v-else class="text-center">
        Choose your camera and cable.
      </h3> -->
      <ArsenalProduct
        v-if="!hide_standard || order.products.arsenal.quantity > 0 || order.products.arsenal.cables.length > 0"
        arsenal_model="Standard"
        :show_arsenal_model="!hide_pro || order.products.arsenal_pro.quantity > 0 || order.products.arsenal_pro.cables.length > 0"
        :added="order.products.arsenal.quantity > 0"
        v-on:arsenal_added="arsenal_added = true"
        :arsenal="order.products.arsenal"
        :prices="order.product_prices ? order.product_prices.arsenal_2_standard : prices.arsenal_2_standard"
        :$v="$v.order.products.arsenal"
        :hidden="
          order.products.arsenal.quantity == 0 &&
          order.products.arsenal_pro.prepopulated
        "
      >
        <ul>
          <li>3x faster than Arsenal 1</li>
        </ul>
      </ArsenalProduct>


      <div
        class="a2-or"
        v-if="!(hide_pro || hide_standard)"
        v-show="
          !order.products.arsenal_pro.prepopulated &&
          !order.products.arsenal.prepopulated
        "
        :class="{
          active:
            order.products.arsenal.quantity == 0 &&
            order.products.arsenal_pro.quantity == 0,
        }"
      >
        or
      </div>


      <ArsenalProduct
        v-if="!hide_pro || order.products.arsenal_pro.quantity > 0 || order.products.arsenal_pro.cables.length > 0"
        arsenal_model="Pro"
        :show_arsenal_model="true"
        :added="order.products.arsenal_pro.quantity > 0 || order.products.arsenal_pro.cables.length > 0"
        v-on:arsenal_added="arsenal_added = true"
        :arsenal="order.products.arsenal_pro"
        :prices="order.product_prices ? order.product_prices.arsenal_2_pro : prices.arsenal_2_pro"
        :$v="$v.order.products.arsenal_pro"
        :hidden="
          order.products.arsenal_pro.quantity == 0 &&
          order.products.arsenal.prepopulated
        "
        :variant="variant"
      >
        <ul>
          <li>5x faster than Arsenal 1</li>
        </ul>
      </ArsenalProduct>
    </section>
    <Accessories
      v-if="variant!=='12.37'"
      header="Great!"
      subheader="Now, choose your accessories."
      :order="order"
      :prices="prices"
      :$v="$v"
      :continental_usa="continental_usa"
      :hide_phone_mount="hide_phone_mount"
      :hide_power_bank="hide_power_bank"
      :hide_micro_sd_card="hide_micro_sd_card"
    />
  </div>
</template>

<script>
import Accessories from "app/components/orders/Accessories";
import ArsenalProduct from "app/components/orders/ArsenalProduct";

export default {
  props: [
    "order",
    "prices",
    "$v",
    "hide_pro",
    "hide_standard",
    "continental_usa",
    "variant",
    "hide_phone_mount",
    "hide_power_bank",
    "hide_micro_sd_card"
  ],
  data() {
    return { arsenal_added: false };
  },
  components: { ArsenalProduct, Accessories },
};
</script>
